module.exports = __webpack_public_path__ + "img/logo_facebook.6caed73f.png";